import AllUpi from "./components/AllInr";

function Upi() {
  return (
    <>
      <AllUpi />
    </>
  );
}

export default Upi;
